<template>

    <div class="w-full">

        <div class="w-full DashboardContainer"></div>

        <div class="w-full bg-white rounded mt-6 shadow-md p-5 clearfix">

            <div class="mb-4">
                <label class="block text-gray-700 text-sm font-bold mb-2">
                    Title <small class="ml-1"><span style="color: red;">MM-DD-YYYY City, ST - Event</span> &mdash; {{ videoDetails.title | count }} characters remaining</small>
                </label>
                <input class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" id="inline-full-name" type="text" v-model="videoDetails.title">
            </div>

            <div class="mb-4">
                <label class="block text-gray-700 text-sm font-bold mb-2">
                    Video Credit <small class="ml-1">Name of the person or entity to receive credit</small>
                </label>
                <input class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" id="inline-full-name" type="text" v-model="videoDetails.user_credit">
            </div>

            <div class="mb-4">
                <label class="block text-gray-700 text-sm font-bold mb-2">
                    Description
                </label>
                <textarea class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" v-model="videoDetails.description" rows="10"></textarea>
            </div>

            <div class="mb-4">
                <label class="block text-gray-700 text-sm font-bold mb-2">
                    Video Type
                </label>
                <!-- <input class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" id="inline-full-name" type="text" v-model="videoDetails.title"> -->
                <select class="dropdown bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" v-model="videoDetails.type">
                    <option value="eng">B-Roll (ENG)</option>
                    <option value="stock">Stock</option>
                </select>
            </div>
            
            <div class="mb-4">
                <label class="block text-gray-700 text-sm font-bold mb-2">
                    Filming Locations
                </label>
                <ul class="locations-ul ml-5" v-if="videoDetails.locationsFromSearch.length > 0">
                    <li class="mt-2 mb-2" v-for="(location, key) in videoDetails.locationsFromSearch">
                        <span>{{ location.text }}</span>
                        <button class="px-2 py-1 bg-red-600 text-white rounded text-xs ml-2" v-on:click="removeLocation(key)">
                            <i class="fa fa-trash"></i>
                        </button>
                    </li>
                </ul>
                <v-select :debounce="250" @search="getOptions" :options="locationSearch" v-model="locationData" placeholder="Search for a location..." label="text"></v-select>
            </div>

            <div class="mb-4">
                <label class="block text-gray-700 text-sm font-bold mb-2">
                    Tags
                </label>
                <input-tag id="tags" :on-change="callbackMethod" :tags="videoDetails.tags" :newTagOnComma="true" class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" style="min-width: 100%; height: auto;"></input-tag>
            </div>

            <div class="mb-4">
                <label class="block text-gray-700 text-sm font-bold mb-2">
                    Content Release
                </label>
                <input id="content-release" type="file" @change="onContentReleaseFileChange" />
            </div>

            <div class="w-full text-center mt-8">
                <button class="bg-blue-700 text-white rounded px-4 py-2" v-on:click="updateVideoDetails" v-if="videoDetails.id !== null">Update Video Details</button>
                <p class="text-gray-700 mt-4" v-if="videoDetails.upload_id == null">You must start your upload before you can save your changes.</p>
            </div>


        </div>

    </div>

</template>

<script>

    import * as Config from '../../config'
    import InputTag from '../general/InputTag.vue'
    import { mapState, mapGetters } from 'vuex';
    var tus = require('tus-js-client');


    import Uppy from '@uppy/core'
    import Dashboard from '@uppy/dashboard'
    import Dropbox from '@uppy/dropbox'
    import Tus from '@uppy/tus'

    import '@uppy/core/dist/style.css'
    import '@uppy/dashboard/dist/style.css'

	export default {
		name: 'HelloWorld',
		data () {
			return {
                tus: tus,
                uploadDetails: {
                    server: 'upload-v2.cdn',
                    startTime: null,
                    endTime: null,
                    elapsedSeconds: 0,
                    bytesUploaded: 0,
                    bytesTotal: 0,
                    fileProgress: 0,
                    uploadingComplete: false,
                    uploadStarted: false,
                    uploadPaused: false,
                },
                videoDetails: {
					id: null,
                    title: null,
                    description: null,
                    locations: [],
					magicKeys: [],
                    locationsFromSearch: [],
                    tags: [],
                    coordinates: [],

                    upload_id: null,
                    upload_filename: null,

                    status: 'upload_progress',
                    progress: 0,

                    type: 'eng',

                    droneVerification: false,
                    category: null,
                    breakdown: null,
                    user_credit: null,
                },
                servers: {},
                categories: [],
                breakdowns: [],

                uploading: false,
                failed: false,
                file: null,
                allowUpdatesToBackend: false,

                locationSearch: [],
                locationData: null,

                uppy: null,
                contentRelease: null,

			}
        },
        components: {
            InputTag,
        },
        mounted() {
            this.getAvailableUploadServers();
            this.getUploadCategories();

            setInterval(function() {
                if(this.uploading == true) {
                    this.updateProgress();
                }
            }.bind(this), 5000);

			this.uppy = Uppy({
				debug: true,
				autoProceed: false,
				restrictions: {
					maxNumberOfFiles: 1,
					minNumberOfFiles: 1,
					allowedFileTypes: ['video/*']
				}
			})
			.use(Dashboard, {
				trigger: '.UppyModalOpenerBtn',
				inline: true,
				target: '.DashboardContainer',
				replaceTargetContent: true,
				showProgressDetails: true,
				note: 'One video file only.',
				height: 400,
				width: '100%',
				browserBackButtonClose: true
			})
			.use(Dropbox, {
                target: Dashboard,
                companionUrl: 'https://cdn-uc.viralnewsservice.com'
            })
			.use(Tus, {
                endpoint: 'https://upload.viralnewsservice.com/files/'
            })

			var _this = this;
			this.uppy.on('complete', result => {

			  if(result.successful.length > 0) {
				  var url = result.successful[0].uploadURL;
				  var file = result.successful[0].data.name;
				  _this.videoDetails.upload_id = url.split('/')[4];
				  _this.videoDetails.upload_filename = _this.videoDetails.upload_id + '.' + file.split('.').pop()
				  _this.finalizeUpload();
			  }

			  if(result.failed.length > 0) {
				  _this.uploadError()
			  }

			})

			this.uppy.on('upload', (data) => {
				this.videoDetails.status = 'uploading';
				_this.initializeVideoUpload()
			})

			this.uppy.on('file-added', (file) => {
				if(this.videoDetails.title == null) {
					this.videoDetails.title = file.name;
				}
			})

			this.uppy.on('upload-progress', (file, progress) => {
				_this.videoDetails.progress = (progress.bytesUploaded / progress.bytesTotal * 100).toFixed(2);
			})

        },
        beforeRouteLeave(route, redirect, next) {
            if(this.videoDetails.status == 'uploading') {
                this.$swal({
                    title: 'Continue?',
                    text: "Your upload has not completed yet. Leaving this page will cancel your upload.",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, leave page.'
                }).then((result) => {
                    if (result.value) {
                        next()
                    } else {
                        return
                    }
                })
            } else {
                next();
            }
            
        },
        methods: {
            ...mapGetters([
                'getAuthorizationHeader',
            ]),
            getAvailableUploadServers() {
                this.$http.get(Config.apiPath + "/api/v2/utilities/servers", this.getAuthorizationHeader()).then((response) => {
                    this.servers = response.data
                });
            },

            getUploadCategories() {
                this.$http.get(Config.apiPath + "/api/v2/stringer/videos/categories", this.getAuthorizationHeader()).then((response) => {
                    this.categories = response.data
                });
            },

            getUploadBreakdowns(id) {
                this.$http.get(Config.apiPath + "/api/v2/stringer/videos/breakdowns/" + id, this.getAuthorizationHeader()).then((response) => {
                    this.breakdowns = response.data
                });
            },


            fileInputChange() {
                this.file = document.getElementById('video').files[0];
                this.setupFileUpload();
            },

            setupFileUpload() {

                // CHANGE THIS: upload url

                this.uploading = true;
                this.failed = false;

                this.uploadDetails.startTime = new Date();

                var self = this;
                var options = {
                    endpoint: "https://" + this.uploadDetails.server + ".livestormsvideo.com/files/",
                    resume: true,

                    metadata: {
                        name: this.file.name,
                        extension: this.file.name.split('.').pop(),
                    },

                    onError: function (error) {
                        if (error.originalRequest) {

                            // prevent from retrying every millisecond... instead wait after 5 seconds
                            setTimeout(function() {
                                options.resume = false
                                options.uploadUrl = self.tusFileUploader.url
                                self.tusFileUploader = new tus.Upload(self.file, options)
                                self.tusFileUploader.start()
                                return
                            }, 5000);

                        } else {
                            window.alert('Failed because: ' + error)
                        }

                        reset()
                    },

                    onProgress: function (bytesUploaded, bytesTotal) {

                        self.uploadDetails.bytesUploaded = bytesUploaded;
                        self.uploadDetails.bytesTotal = bytesTotal;
                        self.videoDetails.progress = (bytesUploaded / bytesTotal * 100).toFixed(2);

                        if(self.videoDetails.upload_id == null) {
                            var url = self.tusFileUploader.url;
                            self.videoDetails.upload_id = url.split('/')[4];
                            self.videoDetails.upload_filename = self.videoDetails.upload_id + '.' + self.file.name.split('.').pop()
                            self.initializeVideoUpload();
                        }

                    },

                    onSuccess: function () {
                        self.uploadDetails.uploadingComplete = true;
                        self.uploading = false;
                        self.finalizeUpload();
                    }

                };

                this.fileUpload(this.file, options);

                if(this.videoDetails.title == null) {
                    var workingTitle = this.file.name;
                    this.videoDetails.title = workingTitle.split('.')[0];
                }

                this.storeUpload();

            },

            fileUpload(file, options) {
                this.tusFileUploader = new this.tus.Upload(file, options);
                this.uploadDetails.uploadStarted = true;
                this.tusFileUploader.start();

                this.videoDetails.status = 'uploading';
            },

            abortFileUpload() {
                this.tusFileUploader.abort();
                this.uploadDetails.uploadPaused = true;
                this.videoDetails.status = 'upload_paused';
                this.updateProgress();
            },

            resumeFileUpload() {
                this.tusFileUploader.start();
                this.uploadDetails.uploadPaused = false;
                this.videoDetails.status = 'uploading';
                this.updateProgress();
            },

            initializeVideoUpload() {

                var formData = this.videoDetails;
                var _this = this;
                this.$http.post(Config.apiPath + "/api/v2/stringer/videos/upload", formData, this.getAuthorizationHeader()).then((response) => {
                    _this.videoDetails.id = response.data.id
                });

            },

            updateVideoDetails() {

                if(this.checkVideoTitle()) {
                    var formData = this.videoDetails;
                    var _this = this;
                    this.$http.post(Config.apiPath + "/api/v2/stringer/videos/upload/" + _this.videoDetails.id, formData, this.getAuthorizationHeader()).then((response) => {
                         _this.$swal(
                                'Updated!',
                                'Your video has been updated.',
                                'success'
                            )
                    });
                }

            },

            finalizeUpload() {

                this.videoDetails.status = 'upload_complete';

                var data = new FormData(); 
                data.append('upload_id', this.videoDetails.upload_id);
                data.append('upload_filename', this.videoDetails.upload_filename);

                data.append('contentRelease', this.contentRelease);
                // data.append('_method', 'put'); // add this


                var _this = this;

                this.$http.post(Config.apiPath + "/api/v2/stringer/videos/upload/" + _this.videoDetails.id + "/finalize", data, {
					headers: {
                        'Authorization': this.getAuthorizationHeader()['headers']['Authorization'],
                        'Accept': 'application/json',
                        'content-type': 'multipart/form-data'
                    }
				}).then((response) => {
                    _this.$swal(
                        'Upload complete!',
                        'Your video has been uploaded.',
                        'success'
                    )
                });

            },

            updateProgress() {

                var formData = {
                    upload_id: this.videoDetails.upload_id,
                    progress: this.videoDetails.progress,
                    status: this.videoDetails.status
                }

                this.$http.post(Config.apiPath + "/api/v2/stringer/videos/upload/" +  _this.videoDetails.id + "/progress", formData, this.getAuthorizationHeader()).then((response) => {
                    console.log(response.data)
                });

            },

            checkVideoTitle() {

                var title = this.videoDetails.title
                var uppercase = title.replace(/[^A-Z]/g, "").length;
                var words = title.split(' ').length;

                // check to see if not more capital letters than words
                if(uppercase > words + 1) {

                    this.$swal({
                        title: 'Your title is not properly formatted.',
                        text: 'Please check the required format under the video.',
                        type: 'error',
                        showCancelButton: false,
                        confirmButtonText: 'I`ll fix it.',
                    });

                    return false;

                }

                // check to see if tite is not greater than 100
                if(title.length > 100) {

                    this.$swal({
                        title: 'Your title is too long!',
                        text: 'You cannot have more than 100 characters for a video title.',
                        type: 'error',
                        showCancelButton: false,
                        confirmButtonText: 'Ok',
                    });

                    return false;
                }

                return true;

            },


            callbackMethod(e) {
                console.log(this.tags);
            },

            newTag(tags) {
                console.log({ tags });
            },

            getOptions(search, loading) {
                loading(true)
				var _this = this
                this.$http.get('https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/suggest?f=json&countryCode=USA%2CPRI%2CVIR%2CGUM%2CASM%2CCAN&category=Postal%2CPopulated+Place&maxSuggestions=10&text=' + search)
                    .then(resp => {
                        _this.locationSearch = resp.data.suggestions
                        loading(false)
                    })
            },

            addLocation() {
                this.videoDetails.locations.push(this.syncedVal.text);
                this.videoDetails.locationsFromSearch.push(this.syncedVal);
                this.syncedVal = null;
            },

            removeLocation(key) {
                this.videoDetails.locations.splice(key, 1)
                this.videoDetails.locationsFromSearch.splice(key, 1)
            },

			uploadError() {
				this.$swal({
					title: 'Upload error',
					text: 'Please try uploading again.',
					type: 'error',
					showCancelButton: false,
					confirmButtonText: 'Ok',
				});
            },

            onContentReleaseFileChange(e) {
                this.contentRelease = document.getElementById('content-release').files[0]
            },

        },
        filters: {
            count: function(data) {
                if(data == null) {
                    return 100
                }
                return (100 - data.length);
            },
        },
        watch: {
            'videoDetails.category': function(val) {
                this.getUploadBreakdowns(val);
            },
			locationData: function(data) {
				console.log(data)
                this.videoDetails.locations.push(data.text)
                this.videoDetails.locationsFromSearch.push(data)
				this.videoDetails.magicKeys.push(data.magicKey)
            }
        }
	}
</script>

<style>
    .uppy-Dashboard {
        z-index: 10 !important;
    }
    .uppy-Dashboard-inner {
        background-color: #fff;
    }
</style>